import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Routes from './Routes/Routes';
import Layout from './Components/Common/Organism/Layout';
import './Statics/Scss/Styles.scss';
import { CookieContext } from './Contexts/CookieContext';
import Hotjar from './Handlers/Hotjar';
import './Helpers/Datadog';
import NotFoundLayout from './Components/Common/Organism/NotFoundLayout';
import PrivateRoute from './Components/Features/PrivateRoute';

const LaNacion = process.env.REACT_APP_LNREDIRECT;

const App = () => {
    if (!window.dataLayer) window.dataLayer = [];

    if (!window.hj) Hotjar.HotjarRun();
    const [updateCookie, setUpdateCookie] = useState(false);
    const [noMatch, setNoMatch] = useState(false);

    return (
        /*Para el seteo de cookies sin tener que pasar por todos los componentes. Usar hook useContext()*/
        <>
            <CookieContext.Provider value={[updateCookie, setUpdateCookie]}>
                {noMatch ? (
                    <NotFoundLayout setNoMatch={setNoMatch} />
                ) : (
                    <Router>
                        <Layout>
                            <Switch>
                                {Routes.map((route, i) => (
                                    <PrivateRoute path={route.path} key={i} exact={true} component={route.component} />
                                ))}
                                <Route>
                                    {()=>setNoMatch(true)}
                                </Route>
                            </Switch>
                        </Layout>
                    </Router>
                )}
            </CookieContext.Provider>
        </>
    );
};

export default App;
